import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { ModalVerConveniosComponent } from '../../@modals/modal-ver-convenios/modal-ver-convenios.component';
import { ModalVerResumenSiniestroComponent } from '../../@modals/modal-ver-resumen-siniestro/modal-ver-resumen-siniestro.component';
import { skipWhile, Subscription, take } from 'rxjs';
import * as compleWeb from '../../@store/complemento-web/complemento-web.actions';
import { ConsultaSiniestroOutput, SiniestroDet } from 'src/app/models/complementos-web/complementos-web.model';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ResultApiResponse } from 'src/app/models/complementos-web/complementos-web-servicios.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { selectDetalleSiniestroSiniestros, selectObjetoDetalleSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { NavSeccionesComplementoComponent } from '../nav-secciones-complemento/nav-secciones-complemento.component';

import { DetalleSiniestroPolizaComponent } from '../detalle-siniestro-poliza/detalle-siniestro-poliza.component';
import { DetalleConductorSiniestroComponent } from '../detalle-conductor-siniestro/detalle-conductor-siniestro.component';
import { DetalleTablaCoberturasSiniestroComponent } from '../detalle-tabla-coberturas-siniestro/detalle-tabla-coberturas-siniestro.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-detalle-complemento',
    templateUrl: './detalle-complemento.component.html',
    styleUrls: ['./detalle-complemento.component.scss'],
    imports: [MatCard, MatCardTitle, NavSeccionesComplementoComponent, MatCardContent, DetalleSiniestroPolizaComponent, DetalleConductorSiniestroComponent, DetalleTablaCoberturasSiniestroComponent, MatCardActions, MatButton]
})
export class DetalleComplementoComponent implements OnInit, OnDestroy {

  public siniestroParams = {
    numeroSiniestro: null
  };

  public perfil: number;
  public loaderComplemento: boolean = false;
  public siniestroComplemento: ConsultaSiniestroOutput;
  public siniestroCompleto: SiniestroDet;
  public listaObservables: Array<Subscription> = [];

  constructor(
    private store: Store<AppState>,
    public router: Router,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private complementoWebService: ComplementoWebService,
    private procesosWebService: ProcesosComunesComplementoService
  ) {
    this.siniestroParams.numeroSiniestro = (this.activatedRoute.snapshot.params?.["siniestro"] as string);
    this.consultarSiniestro(this.siniestroParams.numeroSiniestro);
  }

  ngOnInit(): void {
    this.onReduxChange();
  }

  ngOnDestroy(): void {
    this.store.dispatch(compleWeb.ResetDetalleComplementoWebAction());
    this.listaObservables.forEach(obs => obs.unsubscribe());
  }

  onReduxChange() {
    const complementoWeb = this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)).subscribe({
      next: (value: ConsultaSiniestroOutput) => {
        this.siniestroCompleto = value.Siniestro[0];
      },
    })
    const complementoDetalleWeb = this.store.select(selectDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)).subscribe({
      next: (value) => {
        this.perfil = Number(value?.perfil);
      },
    })
    this.listaObservables.push(complementoWeb);
    this.listaObservables.push(complementoDetalleWeb);
  }

  regresarConsulta() {
    this.router.navigate(['/complemento-web/consulta']);
  }

  abrirModalAccion(nombre: string) {
    if (['CONVENIOS'].includes(nombre)) {
      this.abrirModalConveniosSiniestro();
    }
    if (['RESUMEN_SINIESTRO'].includes(nombre)) {
      this.abrirModalResumenSiniestro();
    }
  }

  abrirModalConveniosSiniestro() {
    const dialog = this.dialog.open(ModalVerConveniosComponent, {
      width: '1800px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { siniestro: this.siniestroCompleto },
    }).afterClosed().subscribe(data => {

    });
  }

  abrirModalResumenSiniestro() {
    const dialog = this.dialog.open(ModalVerResumenSiniestroComponent, {
      width: '1800px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { 
        siniestro: this.siniestroCompleto, 
        siniestroDetalle: this.siniestroComplemento, 
        fechasDetalle: { Perfil: this.perfil },
      },
    }).afterClosed().pipe(take(1)).subscribe(data => {

    });
  }

  consultarSiniestro(siniestro: string, ejecutaLoader: boolean = true) {
    const siniestroFormateado = this.procesosWebService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestroCompleto: `${siniestroFormateado.siniestroCompleto}`,
    }
    if (ejecutaLoader) this.store.dispatch(ActivarLoadingAction());
    else this.loaderComplemento = true;
    this.complementoWebService.consultaSiniestro(request).subscribe({
      next: (value) => {
        if (!ejecutaLoader) this.loaderComplemento = false;
        this.store.dispatch(DesactivarLoadingAction());
        this.procesaDetalleComplemento(value);
      },
      error: (err) => {
        this.loaderComplemento = false;
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
      },
    })
  }

  procesaDetalleComplemento(siniestroDetalle: ResultApiResponse<ConsultaSiniestroOutput>) {
    const estatusSiniestro = siniestroDetalle.Resultado.Siniestro[0].estatus != 4;

    if (estatusSiniestro) {
      return this.regresarConsulta();
    }

    const perfilAdmin = siniestroDetalle.Resultado.perfil_administrador
    const responsabilidadSiniestro = [3, 6].includes(siniestroDetalle.Resultado.Siniestro[0].causa) && Number(perfilAdmin) == 0 ? 2 : siniestroDetalle.Resultado.Siniestro[0].respons_sini;
    const detalleSiniestro = {
      estatus: siniestroDetalle.Resultado.Siniestro[0].estatus,
      perfil: siniestroDetalle.Resultado.perfil,
      perfilAdministrador: perfilAdmin,
      siniestroDetalle: siniestroDetalle.Resultado,
      causa: siniestroDetalle.Resultado.Siniestro[0].causa,
      responsabilidad: responsabilidadSiniestro,
      siniestroCompleto: `${this.siniestroParams.numeroSiniestro}`,
    }
    this.siniestroComplemento = siniestroDetalle.Resultado;
    this.store.dispatch(compleWeb.EstablecerResultDetalleComplementoSVAction({ detalleComplemento: detalleSiniestro }));
  }

}
